var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 1.66699C8.35545 1.66699 7.99476 1.88991 7.81831 2.24281L7.06455 3.75033H3.54167C2.96637 3.75033 2.5 4.2167 2.5 4.79199C2.5 5.36729 2.96637 5.83366 3.54167 5.83366L3.54167 16.2503C3.54167 17.4009 4.47441 18.3337 5.625 18.3337H13.9583C15.1089 18.3337 16.0417 17.4009 16.0417 16.2503V5.83366C16.617 5.83366 17.0833 5.36729 17.0833 4.79199C17.0833 4.2167 16.617 3.75033 16.0417 3.75033H12.5188L11.765 2.24281C11.5886 1.88991 11.2279 1.66699 10.8333 1.66699H8.75ZM6.66667 7.91699C6.66667 7.3417 7.13304 6.87533 7.70833 6.87533C8.28363 6.87533 8.75 7.3417 8.75 7.91699V14.167C8.75 14.7423 8.28363 15.2087 7.70833 15.2087C7.13304 15.2087 6.66667 14.7423 6.66667 14.167V7.91699ZM11.875 6.87533C11.2997 6.87533 10.8333 7.3417 10.8333 7.91699V14.167C10.8333 14.7423 11.2997 15.2087 11.875 15.2087C12.4503 15.2087 12.9167 14.7423 12.9167 14.167V7.91699C12.9167 7.3417 12.4503 6.87533 11.875 6.87533Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f72aa30c0ab8727d0354323dc191f3ba.svg";
export { ForwardRef as ReactComponent };